import { usePermissionContext } from "../../context/Permission";
import { useHttpUtil } from "context/HttpContext";
import { useEffect, useState } from "react";
import TranslucencyMask from "./TranslucencyMask";
import Cookies from "js-cookie";
import Config from "config/config";
import { Plan, User } from "components/types/Types";
import Account from "./Account";
import PayLayout, { SubscribeButton, SubscribeCancelButton, usePayContext } from "components/pay/PayContext";
import Stats from "libs/utils/stats";
import CustomImage from "components/common/CustomImage";
import Tools from "libs/utils/Tools";

export default function Score(props: {children: any, className?: string}){
    return (
        <PayLayout>
            <ScoreContent {...props} />
        </PayLayout>
    )
}


function ScoreContent(props: {children: any, className?: string}){
    const [user, setUser] = useState<User>();
    const permissionContext = usePermissionContext();
    const payContext = usePayContext();
    const httpUtil = useHttpUtil();
    const [isInitPlan, setInitPlan] = useState<boolean>(false);
    const [planList, setPlanList] = useState<Plan[]>();
    const [isShowAccount, setIsShowAccount] = useState<boolean>(false);
    const [name, setName] = useState<string>();

    useEffect(() => {
        isInitPlan && !(planList?.length) && initPlansList()
    },[ isInitPlan ])

    useEffect(() => {
        isShowAccount && !(planList?.length) && initPlansList()
    },[ isShowAccount ])

    
    useEffect(() => {
        permissionContext?.isShowUpgrade && setInitPlan(true)
    },[permissionContext?.isShowUpgrade]);

    useEffect(() => {
        syncUserInfo();
    },[permissionContext?.statsNumber]);

    const syncUserInfo = async () => {
        const res = await httpUtil.post('/biz/user/info',{});
        setName(res.data?.name);
        setUser(res.data)
    }

    const initPlansList = async () => {
        const res = await httpUtil.post('/biz/plan/list',{});
        const list = res.data || [] ;
        const planList = [] ;
        for(let i = 0, len = list.length ;i < len ;i ++){
            // if(!permissionContext?.isShopify && i > 0) continue ; 
            const item = list[i];
            planList.push({
                id : item.planId ,
                name: item.name,
                price: item.price,
                grade : item.grade,
                startTime : item.startTime,
                expireTime : item.expireTime,
                subscribeTime: item.subscribeTime,
                creditValue: item.creditValue,
                creditCycle: item.creditCycle,
                paypalPlanId : item.paypalPlanId,
                items: JSON.parse(item.items),
                prevName : i > 0 ? list[i-1].name : ''
            })
        }
        setPlanList(planList);
    }

    const openOrClose = () => {
       !payContext?.isProcessing && permissionContext?.upgrade();
    }

    const showAccount = () => {
        setIsShowAccount(true);
    }

    const hiddenAccount = () => {
        setIsShowAccount(false);
    }

    const logout = async () => {
        const resData = await httpUtil.post('/biz/user/logout');
        if(!resData.errCode){
            Tools.removeCookie('PF')
            Tools.removeCookie('Authorization')
            Tools.removeCookie('UR')
        }
        location.href = Tools.disponseUrl(Config.websiteUrl)
    }

    const {children, className = ''} = props ;
    return (
        <>
            <div className={className}>
                <div className="flex gap-[10px]">
                    {children}
                    <div className="flex justify-center">
                        <span className="flex items-center gap-[6px] px-[14px] border border-[#10F28D] border-r-0 rounded-l-[10px] text-[#14A5FA]">
                            <CustomImage src="/icon/icon-score.png" className="w-[20px] h-[20px]"/> 
                            <span>{user?.credit}</span>
                        </span>
                        <button className="flex items-center rounded-r-[10px] bg-gradient-to-r from-[#14A5FA] to-[#10F28D] text-[#FFFFFF] px-[10px] text-[12px] xl:small-txt"
                            onClick={openOrClose}>Upgrade</button>
                    </div>
                    <div className="flex justify-center px-[10px] py-[6px] bg-[#f4da73] rounded-[10px] cursor-pointer"
                        onClick={() => { Stats.google('Tutorials'); window.open('https://www.mockuplabs.ai/tutorials') }}>
                        <CustomImage src="/icon/icon-tool-help.png" className="w-[22px] h-[22px] xl:w-[24px] xl:h-[24px]"/>
                    </div>
                    <div className="group relative flex w-[35px] h-[35px] items-center justify-center rounded-full bg-[#e4e5e7] cursor-pointer">
                        <span>{name?.substring(0,2).toLocaleUpperCase()}</span>

                        <div className="absolute right-0 top-[30px] w-[270px] pt-[10px] hidden group-hover:block z-[10008]">
                            <div className="w-full rounded-[5px]  flex flex-col bg-[#FFFFFF] shadow-box">
                                <div className="p-[20px] flex gap-[15px]  border-b items-center">
                                    <span className="flex flex-none items-center justify-center w-[40px] h-[40px] rounded-full bg-[#e4e5e7]">{name?.substring(0,2).toLocaleUpperCase()}</span>
                                    <div className="grow flex flex-col overflow-hidden relative gap-[5px]">
                                        <span className="text-[#000000] font-semibold small-txt truncate max-w-[100px]">{user?.name}</span>
                                        <span className="sosmall-txt text-[#7B7B7B]">{user?.email}</span>
                                        <span className="absolute right-[0px] top-[0px] bg-[#EFEFEF] rounded-[5px] px-[10px] py-[3px]">{user?.planName}</span>
                                    </div>
                                </div>
                                <div className="px-[20px] py-[10px] mt-[10px] hover:bg-[#D9F2FF] cursor-pointer flex gap-[15px] items-center font-normal text-[14px]"
                                         onClick={showAccount}>
                                    <CustomImage src="/icon/account/icon-account.png" className="w-[20px] h-[20px]"/>
                                    <span>My Account</span>
                                </div>
                                <div className="px-[20px] py-[10px] mt-[10px] hover:bg-[#D9F2FF] cursor-pointer flex gap-[15px] items-center font-normal text-[14px]"
                                    onClick={openOrClose}>
                                    <CustomImage src="/icon/account/icon-plan.png" className="w-[20px] h-[20px]"/>
                                    <span>Price and plans</span>
                                </div>
                                <div className="px-[20px] py-[10px] mt-[10px] hover:bg-[#D9F2FF] cursor-pointer flex gap-[15px] items-center font-normal text-[14px]"
                                    onClick={() => { Stats.google('Help'); window.open('https://www.mockuplabs.ai/tutorials') }}>
                                    <CustomImage src="/icon/account/icon-help.png" className="w-[20px] h-[20px]"/>
                                    <span>Help center</span>
                                </div>
                                <div className="px-[20px] py-[10px] mt-[10px] hover:bg-[#D9F2FF] cursor-pointer flex gap-[15px] items-center font-normal text-[14px]"
                                    onClick={() => { Stats.google('Homepage'); window.open('https://www.mockuplabs.ai/') }}>
                                    <CustomImage src="/icon/account/icon-website.png" className="w-[20px] h-[20px]"/>
                                    <span>Go to homepage</span>
                                </div>
                                {
                                    !permissionContext?.isShopify && 
                                    <div className="px-[20px] py-[15px] mt-[10px] border-t rounded-b-[5px] hover:bg-[#D9F2FF] cursor-pointer flex gap-[15px] items-center font-normal text-[14px]"
                                            onClick={logout}>
                                        <CustomImage src="/icon/account/icon-logout.png" className="w-[20px] h-[20px]"/>
                                        <span>Logout</span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                permissionContext?.isShowUpgrade &&
                <TranslucencyMask className="z-[10010]" closeHandler={openOrClose}>
                    <div className="absolute xl:w-[850px] w-[70%] max-h-[85%] overflow-y-auto left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] xl:px-[90px] px-[40px] py-[30px] bg-[#FFFFFF] rounded-[20px]"
                        onClick={(e) => e.stopPropagation()}>
                        <CustomImage src="/icon/icon-close.png" className="absolute right-[30px] top-[30px] w-[30px] cursor-pointer " 
                            onClick={openOrClose}/>
                        <h4 className="text-[20px] xl:text-[24px] font-bold text-center">Unlock magic with Mockuplabs advanced program</h4>
                        <p className="text-center medium-txt font-semibold mt-[20px]">Take advantage of Mockuplabs product mockup generator and our suite of ecommerce and editing AI tools to get more done quickly and efficiently.</p>
                        <div className="flex gap-[30px] mt-[20px] xl:mt-[40px] justify-center">
                            {
                                planList?.map((item : Plan) => (
                                    <div className="basis-1/2 h-full border border-[#D9D9D9] rounded-[10px] pt-[20px] xl:pt-[30px] pb-[20px] px-[20px]"
                                        style={{
                                            borderColor : user?.planId == item.id ? '#14A5FA' : '#D9D9D9',
                                            borderWidth : user?.planId == item.id ? '2px' : '1px'
                                        }}
                                        key={item.id}>
                                        <p className="text-[20px] xl:text-[24px] font-bold text-center">{item.name}</p>
                                        <p className="text-[36px] xl:text-[42px] font-bold text-center mt-[15px] xl:mt-[30px]">${item.price}/mo</p>
                                        <div className="flex flex-col h-[200px] xl:h-[240px] pl-[20px] xl:pl-[40px] mt-[15px] xl:mt-[30px]">
                                            <span className="small-txt font-semibold">{item.prevName ? (`Everything in ${item.prevName} +`) : 'Try all features'}</span>
                                            {
                                                item.items.map((str: string, index: number) => (
                                                    <div className="flex items-start gap-[10px] mt-[10px]" key={index}>
                                                        <CustomImage src="/icon/icon-plan-item.png" className="w-[20px]" /><span className="small-txt font-semibold">{str}</span>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        {
                                            item.grade == 1 &&
                                            <div className="border border-[#000000] rounded-[10px] w-full py-[15px] medium-txt font-semibold text-center">{item.id == user?.planId ? 'Current plan' : 'Default plan'}</div>
                                        }
                                        {
                                            item.grade > 1 && 
                                            (
                                                item.id != user?.planId ? 
                                                    <SubscribeButton plan={item} txt="Upgrade plan"  className="w-full py-[15px] medium-txt font-semibold justify-center " rounded={10} isPaypalLarge={true} />
                                                :
                                                item.id == user.planId &&
                                                (
                                                    user.subscribeStatus == 1 ? 
                                                        <SubscribeCancelButton className="bg-[#000000] w-full py-[15px] medium-txt font-semibold justify-center" rounded={10} />
                                                    :
                                                        <SubscribeButton plan={item} txt="Renew now" className="w-full py-[15px] medium-txt font-semibold justify-center " rounded={10} isPaypalLarge={true} />
                                                )
                                            )
                                        }
                                        
                                    </div>
                                ))
                            }
                        </div>
                        <div className="text-right mt-[10px]">
                            <CustomImage src="/icon/icon-help.png" className="w-[20px] inline-block align-middle" />
                            <span className="text-[#BFBFBF] small-txt cursor-pointer inline-block align-middle ml-[5px]"
                                onClick={() => window.open('https://www.mockuplabs.ai/resources/rules')}>Subscription credits rules</span>
                        </div>
                    </div>
                </TranslucencyMask>
            }

            
            {
                isShowAccount &&  <Account user={user as User} planList={planList as Plan[]} cancel={hiddenAccount}></Account>
            }
        </>
    )
}
